/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    orientation: PropTypes.oneOfType([
        PropTypes.oneOf(['top', 'right', 'left']),
        PropTypes.arrayOf(PropTypes.oneOf([
            'top',
            'right',
            'left',
        ])),
    ]),
};

const defaultProps = {
    ...commonDefaultProps,
};

const PopoverContainer = (props) => {
    let orientationClasses = null;
    if (Array.isArray(props.orientation)) {
        orientationClasses = props.orientation.reduce((
            orientationClassNames,
            currentOrientation,
            index,
        ) => (
            index === 0
                ? `c-popover__container--${currentOrientation}`
                : `${orientationClassNames} c-popover__container--${currentOrientation}`
        ), '');
    } else {
        orientationClasses = `c-popover__container--${props.orientation}`;
    }

    const classNames = [
        'c-popover__container',
        'c-popover__container-react',
        props.orientation ? orientationClasses : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];

    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            // Have to overwrite container css class
            style={{ display: 'block' }}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

PopoverContainer.propTypes = propTypes;

PopoverContainer.defaultProps = defaultProps;

export default PopoverContainer;
